import { forwardRef, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TimeLineContext } from "../timeline.config";
import { IndicatorPlayPosition, IndicatorFocus, GetTimelineGridInfo, GetFieldWidth, zoomChangeIndication } from "./commonFunction";
import { activeVideoUUID_Store, activeTextUUID_Store, activeImageUUID_Store, activeAudioUUID_Store } from "../../../../store/actions/projectdata";
import { TimeCount_Store, SaveVideoPlaying_Store } from "../../../../store/actions/videoPlayAction";
import {switchVideo_Store} from "../../../../store/actions/webgldata";

export const Indicator = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [timelineData, setTimelineData] = useContext(TimeLineContext);
  const projectJSON = useSelector((store => store.projectdata.projectJSON));
  const dataLoaded = useSelector(store => store.webgldata.dataLoaded);
  //const isAddedTemplate = useSelector(store => store.projectdata.addedTemplate)
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const audioElements = useSelector(store => store.webgldata.audioElements);
  const VideoPlaying = useSelector((store) => store.videodata.videoPlaying);
  const activeVideoUUID = useSelector(store => store.projectdata.activeVideoUUID);
  const activeAudioUUID = useSelector(store => store.projectdata.activeAudioUUID);
  const zoomRate = useSelector((store) => store.videodata.zoomRate);
  const Time_Count = useSelector((store) => store.videodata.Time_Count);
  const projectVolume = useSelector((store) => store.projectdata.projectVolume);
  const isTimelineScroll = useSelector((store) => store.editdata.isTimelineScroll);
  const isChangeSegment = useSelector((store) => store.editdata.isChangeSegment);
  const isScrubbingRef = useRef(false);
  const wasPlayingBeforeScrubRef = useRef(false);
  const playbackFrameRef = useRef(null);
  const dragFrameRef = useRef(null);
  const dragClientXRef = useRef(null);
  const playbackStartClockRef = useRef(0);
  const playbackStartTimeRef = useRef(0);
  const latestTimeRef = useRef(Time_Count.getTime());
  const lastReduxSyncRef = useRef(0);
  const resumePlaybackTimerRef = useRef(null);
  const isTimelineEditingRef = useRef(false);
  const isTimelineEditing = !!timelineData.dragingGroups || isChangeSegment;
  let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }
  
  useEffect(() => {
    const legendInfo = GetTimelineGridInfo(zoomRate);
    const { zoom, diffCount, sRuller, sChild } = legendInfo;
    setTimelineData({ ...timelineData, legendInfo: legendInfo, });
  }, [zoomRate]);

  useEffect(() => {
    if (!timelineData.indicator) return;
    const timeContainer = timelineData.container;
    const ScrollTop = timeContainer.scrollTop;
    (async () => {
     
      await zoomChangeIndication(timelineData, Time_Count);
      await IndicatorFocus(timelineData, 'zoom', isTimelineScroll);
      setTimeout(() => {
        timeContainer.scrollTop = ScrollTop;
      }, 10);
    })()
  }, [timelineData.legendInfo]);

  const setIndicatorPosition = (timeMs) => {
    if (!timelineData.indicator) return 0;
    const { SecondW } = GetFieldWidth(timelineData.legendInfo);
    const nextLeft = (SecondW * timeMs / 1000) + 10;
    timelineData.indicator.style.left = `${nextLeft}px`;
    return nextLeft;
  }

  const moveIndicatorToClientX = (clientX) => {
    if (!timelineData.timeline || !timelineData.elements || !timelineData.indicator) return latestTimeRef.current;
    const timelineRect = timelineData.timeline.getBoundingClientRect();
    const edgeX = clientX - timelineRect.left;
    const indicatorMarginLeft = parseFloat(
      timelineData.indicator.style.marginLeft || window.getComputedStyle(timelineData.indicator).marginLeft
    ) || 0;
    if (edgeX < 24 && timelineData.timeline.scrollLeft > 0) {
      timelineData.timeline.scrollLeft = Math.max(0, timelineData.timeline.scrollLeft - 24);
    }
    if (edgeX > timelineRect.width - 24) {
      const maxScroll = timelineData.timeline.scrollWidth - timelineData.timeline.offsetWidth;
      timelineData.timeline.scrollLeft = Math.min(maxScroll, timelineData.timeline.scrollLeft + 24);
    }
    const scrollLeft = timelineData.timeline.scrollLeft;
    const totalW = timelineData.elements.offsetWidth;
    let nextLeft = scrollLeft + clientX - timelineRect.left - indicatorMarginLeft;

    if (nextLeft < 10) nextLeft = 10;
    if (nextLeft > totalW - 40) nextLeft = totalW - 40;

    timelineData.indicator.style.left = `${nextLeft}px`;
    if (!isTimelineScroll) IndicatorFocus(timelineData, 'scrub', isTimelineScroll);
    const { SecondW } = GetFieldWidth(timelineData.legendInfo);
    return Math.max(0, (nextLeft - 10) / SecondW * 1000);
  }

 // const [activePlayID, setActivePlayID] = useState();
  useEffect(() => {
    latestTimeRef.current = Time_Count.getTime();
    playbackStartClockRef.current = performance.now();
    playbackStartTimeRef.current = latestTimeRef.current;
  }, [Time_Count]);

  useEffect(() => {
    isTimelineEditingRef.current = isTimelineEditing;
  }, [isTimelineEditing]);

  useEffect(() => {
    if (!VideoPlaying || !timelineData.indicator) {
      if (playbackFrameRef.current) cancelAnimationFrame(playbackFrameRef.current);
      playbackFrameRef.current = null;
      return;
    }

    playbackStartClockRef.current = performance.now();
    playbackStartTimeRef.current = latestTimeRef.current;

    const tick = (now) => {
      if (!VideoPlaying || isScrubbingRef.current) {
        playbackFrameRef.current = requestAnimationFrame(tick);
        return;
      }

      const nextTime = playbackStartTimeRef.current + (now - playbackStartClockRef.current);
      latestTimeRef.current = nextTime;
      const nextLeft = setIndicatorPosition(nextTime);
      const totalTime = projectJSON.duration || timelineData.maxTime * 1000;

      if (nextTime > totalTime || nextLeft >= timelineData.maxTime * GetFieldWidth(timelineData.legendInfo).SecondW) {
        dispatch(SaveVideoPlaying_Store(false));
        return;
      }

      if (now - lastReduxSyncRef.current > 100) {
        lastReduxSyncRef.current = now;
        dispatch(TimeCount_Store(new Date(nextTime)));
      }

      playbackFrameRef.current = requestAnimationFrame(tick);
    }

    playbackFrameRef.current = requestAnimationFrame(tick);
    return () => {
      if (playbackFrameRef.current) cancelAnimationFrame(playbackFrameRef.current);
      playbackFrameRef.current = null;
    }
  }, [VideoPlaying, timelineData.indicator, timelineData.legendInfo, projectJSON.duration]);

  useEffect(() => {
    videoPlayFunc(Time_Count);

  }, [Time_Count, VideoPlaying, projectJSON, dataLoaded])

  useEffect(() => {
    timeCountSync();
  }, [isTimelineScroll])

  useEffect( () => {
    timeCountSync();
    // const totalTime = projectJSON.duration;
    // const currentTime = Time_Count.getTime();

    // if (currentTime > totalTime && VideoPlaying) {
    //   let videoElKeys = Object.keys(videoElements);
    //   videoElKeys.forEach((key) => {
    //     if (!!projectJSON.videos[key]) {
    //       let videoEl = videoElements[key];
    //       let videoJSON = Object.assign({}, projectJSON.videos[key]);
    //       let segment_start = videoJSON.segment_start / 1000;
    //       videoEl.currentTime = segment_start;
          
    //     }
    //   })
    //   //dispatch(TimeCount_Store(new Date(0)));
    // }

    // if (!timelineData.indicator) return;
    // await IndicatorPlayPosition(timelineData, Time_Count, dispatch, isTimelineScroll);
    // IndicatorFocus(timelineData, 'play', isTimelineScroll);
  }, [Time_Count])
  const timeCountSync = async () => {
    const totalTime = projectJSON.duration;
    const currentTime = Time_Count.getTime();

    if (currentTime > totalTime && VideoPlaying) {
      let videoElKeys = Object.keys(videoElements);
      videoElKeys.forEach((key) => {
        if (!!projectJSON.videos[key]) {
          let videoEl = videoElements[key];
          let videoJSON = Object.assign({}, projectJSON.videos[key]);
          let segment_start = videoJSON.segment_start / 1000;
          videoEl.currentTime = segment_start;
          
        }
      })
      //dispatch(TimeCount_Store(new Date(0)));
    }

    if (!timelineData.indicator) return;
    await IndicatorPlayPosition(timelineData, Time_Count, dispatch, isTimelineScroll);
    if (!isTimelineEditingRef.current) {
      IndicatorFocus(timelineData, 'play', isTimelineScroll);
    }
  }
  /*useEffect(() => {
    if(activePlayID){
      dispatch(switchVideo_Store({
        isSwitching: true,
        videoID: activePlayID
      }));
    }
  }, [activePlayID])*/

  useEffect(() => {
    stopDomVideoPlayers(Time_Count);
  }, [Time_Count, activeVideoUUID])

  const stopDomVideoPlayers = async (timeCount) => {
    const currentTime          = timeCount.getTime();
    const tempVideos           = Object.assign({}, projectJSON.videos);
    const [activeVideos]       = await getActiveElements(tempVideos, currentTime, 'video');
    const videoKeys            = Object.keys(activeVideos);
    const activeVideoPlayers = await getActiveDomVideoPlayers();

    if (activeVideoPlayers) {
      for (let index=0; index<activeVideoPlayers.length; index++) {
        let activeVideoPlayer = activeVideoPlayers[index];

        const current_associated_timeline_video_element_uuid = activeVideoPlayer.getAttribute('data-timeline-element-uuid');
        const checkActiveVideoPlayer = videoKeys.find((vKey) => vKey === current_associated_timeline_video_element_uuid);

        if (!VideoPlaying || !checkActiveVideoPlayer) {
          activeVideoPlayer.pause();
        }
      }
    }
  };

  const videoPlayFunc = async (timeCount) => {
    const currentTime = timeCount.getTime();
    const tempVideos = Object.assign({}, projectJSON.videos);
    const tempAudios = Object.assign({}, projectJSON.audios);
    const tempTexts = Object.assign({}, projectJSON.text);
    const tempImages = Object.assign({}, projectJSON.images);
    
    const [activeVideos] = await getActiveElements(tempVideos, currentTime, 'video');
    const [activeAudios] = await getActiveElements(tempAudios, currentTime, 'audio');
    const [activeTexts] = await getActiveElements(tempTexts, currentTime, 'text');
    const [activeImages] = await getActiveElements(tempImages, currentTime, 'image');

    const videoKeys = Object.keys(activeVideos);
    const audioKeys = Object.keys(activeAudios);
    const textKeys = Object.keys(activeTexts);
    const ImageKeys = Object.keys(activeImages);
    const videoElKey = Object.keys(videoElements);
    const audioElKey = Object.keys(audioElements);

    const [activeVideoPlayers] = await getActiveDomVideoPlayers();

    videoKeys.forEach((key) => {
      let previous_checkActiveEl = activeVideoUUID.find((vKey) => vKey === key && VideoPlaying);
      let checkActiveEl = videoKeys.find((vKey) => vKey === key && VideoPlaying);

      let videoEL = videoElements[key];
      let videoItem = activeVideos[key];

      if (checkActiveEl && !previous_checkActiveEl) {
        videoEL.currentTime = videoItem.segment_start / 1000;
      } else if (!checkActiveEl && previous_checkActiveEl) {
        videoEL.pause();
      } else {
        // Commented out audio fade out now, it makes UI so slow.
        // const originAudioVolume = (videoItem.volume * (projectVolume / 200));
        // const outPutAudioVolume = fadeInOutVolumeValue(videoEL.duration, videoEL.currentTime, originAudioVolume, videoItem);
        // videoEL.volume = outPutAudioVolume;
        let new_volume = videoItem.volume * (projectVolume / 200);
        if (videoEL.volume != new_volume) videoEL.volume = new_volume;
      }
    })

    audioElKey.forEach((key) => {
      const audioItem = tempAudios[key];
      const audioEl = audioElements[key];
      const checkActiveEl = audioKeys.find((aKey) => aKey === key && VideoPlaying);
     
      if (!checkActiveEl) {
        audioEl.pause();
        //audioEl.volume = 0;
      } else {
        // Commented out audio fade out now, it makes UI so slow.
        // const originAudioVolume = (audioItem.volume * (projectVolume / 200));
        // const outPutAudioVolume = fadeInOutVolumeValue(audioEl.duration, audioEl.currentTime, originAudioVolume, audioItem);
        // audioEl.volume = outPutAudioVolume;
        let new_volume = audioItem.volume * (projectVolume / 200);
        if (audioEl.volume != new_volume) audioEl.volume = new_volume;
      }
    })

    if (activeVideoUUID !== videoKeys) dispatch(activeVideoUUID_Store(videoKeys));
    dispatch(activeAudioUUID_Store(audioKeys));
    dispatch(activeImageUUID_Store(ImageKeys));
    dispatch(activeTextUUID_Store(textKeys));

    videoKeys.forEach((videoKey) => {
      const videoItem = activeVideos[videoKey];
      const videoEl = videoElements[videoKey];
      const tempVideos = Object.assign({}, projectJSON.videos);

      let all_video_elements = document.getElementsByClassName("myElement_videos");
      let all_video_elements_array = Array.from(all_video_elements);

      let current_video_player;
      all_video_elements_array.forEach((element, index) => {
        const elementUuid = element.getAttribute('data-asset-uuid');
        if (elementUuid === videoItem.asset_uuid) {
          current_video_player = element;
        }
      });

      if (current_video_player) {
        const videoPaused = current_video_player.paused;
        const videoCurrentTime = videoItem.segment_start + (currentTime - videoItem.timeline_start);
        current_video_player.setAttribute('data-timeline-element-uuid', videoKey);

        if (VideoPlaying && videoPaused) {
          current_video_player.play();
        }
        if (!VideoPlaying) {
          try{
            current_video_player.pause();
          }catch(e){
            console.log('Error while pausing:', e);
          }
        }
        if (!VideoPlaying) {
          const segmentStart = Number(videoItem.segment_start) / 1000;
          const segmentEnd = Number(videoItem.segment_end) / 1000;
          const unclampedTime = videoCurrentTime / 1000;
          const maxSeekTime = Number.isFinite(segmentEnd) ? Math.max(segmentStart, segmentEnd - 0.001) : unclampedTime;
          const targetTime = Math.max(segmentStart, Math.min(maxSeekTime, unclampedTime));
          const seekTolerance = mobileScreenDetect ? 0.04 : 0.016;
          if (Number.isFinite(targetTime) && Math.abs(current_video_player.currentTime - targetTime) > seekTolerance) {
            current_video_player.currentTime = targetTime;
          }
        }
      } else {
        console.log('No matching video player found for the given asset UUID');
      }
    })

    audioKeys.forEach((audioKey) => {
      const audioItem = activeAudios[audioKey];
      const audioEl = audioElements[audioKey];
      if (!audioEl) return;

      const audioPaused = audioEl.paused;
      const audioCurrentT = audioItem.segment_start + currentTime - audioItem.timeline_start;

      if (VideoPlaying && audioPaused) audioEl.play();
      if (!VideoPlaying && !audioPaused) audioEl.pause();
      if (!VideoPlaying) audioEl.currentTime = audioCurrentT / 1000;
    })
  }

  useEffect(() => {
    // let videoElKeys = Object.keys(videoElements);
    // videoElKeys.forEach((key) => {
    //   let checkActive = activeVideoUUID.indexOf(key);
    //   if (checkActive === -1 && !!projectJSON.videos[key]) {
    //     let videoEl = videoElements[key];
    //     let currentTime = videoEl.currentTime;
    //     let videoJSON = Object.assign({}, projectJSON.videos[key]);
    //     let segment_start = videoJSON.segment_start / 1000;
    //     //if (currentTime !== segment_start) videoEl.currentTime = mobileScreenDetect ? segment_start + 1 : segment_start;
    //   }
    // })

    let audioKeys = Object.keys(audioElements);
    audioKeys.forEach((key) => {
      let checkActive = activeAudioUUID.indexOf(key);
      if (checkActive === -1 && !!projectJSON.audios[key]) {
        let audioEl = audioElements[key];
        let currentTime = audioEl.currentTime;
        let audioJSON = Object.assign({}, projectJSON.audios[key]);
        let segment_start = audioJSON.segment_start / 1000;
        if (currentTime !== segment_start) audioEl.currentTime = segment_start;
      }
    })
  }, [VideoPlaying])

  const getActiveDomVideoPlayers = async () => {
    let all_video_elements = document.getElementsByClassName("myElement_videos");
    let all_video_elements_array = Array.from(all_video_elements);
    return all_video_elements_array;
  }

  const getActiveElements = async (ElementsOb, currentTime, type) => {
    const keys = Object.keys(ElementsOb);
    let ActiveOb = {};
    const totalTime = projectJSON.duration;
    keys.forEach((key) => {
      const Ob = ElementsOb[key];
      if (!Ob?.disable_video) {
        const timeStart = Ob.timeline_start;
        const timeEnd = Ob.timeline_end;
        if (timeStart <= currentTime && currentTime < timeEnd) {
          ActiveOb[key] = Ob
          if(type == 'video'){
            const endTransition = Ob.transition?.end;
            const transitionDuration = Math.max(100, Number(endTransition?.duration) || 500);
            const hasTransitionTarget = endTransition?.associated_texture && endTransition.associated_texture !== '-';
            if(endTransition?.preset != '-' && hasTransitionTarget && currentTime > (timeEnd - transitionDuration) && Ob.timeline_end < totalTime){
              //setActivePlayID(key);
              dispatch(switchVideo_Store({
                isSwitching: true,
                videoID: key
              }));
            }
          }
        }
      }
    })
    return [ActiveOb]
  }

  const syncScrubTime = (timeMs, force = false) => {
    const now = performance.now();
    latestTimeRef.current = timeMs;
    if (force || now - lastReduxSyncRef.current > 80) {
      lastReduxSyncRef.current = now;
      dispatch(TimeCount_Store(new Date(timeMs)));
    }
  }

  const onPointerDown = (e) => {
    if (!timelineData.indicator) return;
    e.preventDefault();
    if (resumePlaybackTimerRef.current) clearTimeout(resumePlaybackTimerRef.current);
    isScrubbingRef.current = true;
    wasPlayingBeforeScrubRef.current = VideoPlaying;
    if (VideoPlaying) dispatch(SaveVideoPlaying_Store(false));
    e.currentTarget.setPointerCapture?.(e.pointerId);
    e.currentTarget.style.cursor = 'grabbing';
    e.currentTarget.style.opacity = 0.7;
    dragClientXRef.current = e.clientX;
    const scrubTime = moveIndicatorToClientX(e.clientX);
    syncScrubTime(scrubTime, true);
  }

  const onPointerMove = (e) => {
    if (!isScrubbingRef.current || dragClientXRef.current === null) return;
    e.preventDefault();
    dragClientXRef.current = e.clientX;
    if (dragFrameRef.current) return;
    dragFrameRef.current = requestAnimationFrame(() => {
      dragFrameRef.current = null;
      const scrubTime = moveIndicatorToClientX(dragClientXRef.current);
      syncScrubTime(scrubTime);
    });
  }

  const onPointerUp = (e) => {
    if (!isScrubbingRef.current) return;
    e.preventDefault();
    if (dragFrameRef.current) {
      cancelAnimationFrame(dragFrameRef.current);
      dragFrameRef.current = null;
    }
    const clientX = Number.isFinite(e.clientX) ? e.clientX : dragClientXRef.current;
    if (Number.isFinite(clientX)) {
      const scrubTime = moveIndicatorToClientX(clientX);
      syncScrubTime(scrubTime, true);
    }
    e.currentTarget.releasePointerCapture?.(e.pointerId);
    e.currentTarget.style.cursor = 'grab';
    e.currentTarget.style.opacity = 1;
    dragClientXRef.current = null;
    isScrubbingRef.current = false;
    dispatch(switchVideo_Store({
      isSwitching: false,
      videoID: ''
    }));
    if (wasPlayingBeforeScrubRef.current) {
      resumePlaybackTimerRef.current = setTimeout(() => {
        playbackStartClockRef.current = performance.now();
        playbackStartTimeRef.current = latestTimeRef.current;
        dispatch(SaveVideoPlaying_Store(true));
      }, 30);
    }
    wasPlayingBeforeScrubRef.current = false;
  }

  useEffect(() => {
    return () => {
      if (playbackFrameRef.current) cancelAnimationFrame(playbackFrameRef.current);
      if (dragFrameRef.current) cancelAnimationFrame(dragFrameRef.current);
      if (resumePlaybackTimerRef.current) clearTimeout(resumePlaybackTimerRef.current);
    }
  }, []);

  return (
    <div className='v-timeline-indicator v-center' ref={ref}
      onPointerDown={onPointerDown} onPointerMove={onPointerMove}
      onPointerUp={onPointerUp} onPointerCancel={onPointerUp}
    />
  );
});
